import { useState } from 'react';
import { CallaboDialog, DialogOptions } from './CallaboDialog';

interface Props {
  children: [
    (props: { open: () => void }) => JSX.Element,
    (props: { close: () => void }) => JSX.Element
  ];
  options?: DialogOptions;
  closable?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
}

export const CallaboDialogWithButton = ({
  children,
  options,
  closable,
  onOpen,
  onClose,
}: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
    onOpen?.();
  };

  const handleClose = () => {
    closable && setIsOpen(false);
    onClose?.();
  };

  return (
    <>
      {children[0]({ open: handleOpen })}
      <CallaboDialog isOpen={isOpen} onClose={handleClose} options={options}>
        {children[1]({
          close: () => {
            setIsOpen(false);
            onClose?.();
          },
        })}
      </CallaboDialog>
    </>
  );
};
